import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import ResumeTitle from "./ResumeTitle";
import { MdWork, MdKeyboardArrowDown } from "react-icons/md";
import { GiGraduateCap } from "react-icons/gi";
import ResumeCard from "./ResumeCard";
import { experience, education } from "../../data/experience";

// Below "lgl" (1024px): an accordion — one group open at a time — instead
// of four job cards stacked directly on top of two degree cards. At "lgl"
// and up: unchanged, the original two-column layout.
const groups = [
  { id: "experience", label: "Experience", icon: <MdWork />, items: experience },
  { id: "education", label: "Education", icon: <GiGraduateCap />, items: education },
];

const Education = () => {
  const [openId, setOpenId] = useState("experience");

  return (
    <>
      <div className="w-full flex flex-col gap-3 px-7 pt-4 lgl:hidden">
        {groups.map(({ id, label, icon, items }) => {
          const isOpen = openId === id;
          return (
            <div key={id} className="borderAll rounded-xl overflow-hidden">
              <button
                type="button"
                onClick={() => setOpenId(isOpen ? null : id)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-2 px-4 py-3.5 text-left bg-surfaceColor active:brightness-90 transition duration-150"
              >
                <span className="flex items-center gap-2 text-mutedColor uppercase text-sm font-medium">
                  <span className="text-designColor text-xl">{icon}</span>
                  {label}
                  <span className="text-faintColor normal-case">({items.length})</span>
                </span>
                <MdKeyboardArrowDown
                  className={`text-xl text-mutedColor duration-300 ${
                    isOpen ? "rotate-180" : ""
                  }`}
                />
              </button>
              <AnimatePresence initial={false}>
                {isOpen && (
                  <motion.div
                    key="content"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeOut" }}
                    className="overflow-hidden"
                  >
                    <div className="px-4 pb-2 border-t-[1px] border-lineColor">
                      {items.map((item) => (
                        <ResumeCard key={`${item.title}-${item.badge}`} {...item} />
                      ))}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          );
        })}
      </div>

      <div className="w-full hidden lgl:grid grid-cols-9 px-6 gap-6">
        {/* Experience Section */}
        <div className="col-span-9 md:col-span-4">
          <ResumeTitle title="Experience" icon={<MdWork />} />
          {experience.map((job) => (
            <ResumeCard key={`${job.title}-${job.badge}`} {...job} />
          ))}
        </div>

        {/* Divider */}
        <div className="w-full h-full hidden lgl:flex justify-center items-center">
          <span className="w-[1px] h-full bg-lineColor inline-flex"></span>
        </div>

        {/* Education Section */}
        <div className="col-span-9 md:col-span-4">
          <ResumeTitle title="Education" icon={<GiGraduateCap />} />
          {education.map((entry) => (
            <ResumeCard key={entry.title} {...entry} />
          ))}
        </div>
      </div>
    </>
  );
};

export default Education;
